// extracted by mini-css-extract-plugin
var _1 = "ra-cms-module-testimonial-author";
var _2 = "ra-cms-module-testimonial";
var _3 = "ra-cms-module-testimonial-details";
var _4 = "ra-cms-module-testimonial-footer";
var _5 = "ra-cms-module-testimonial-link";
var _6 = "ra-cms-module-testimonial-stars";
var _7 = "ra-cms-module-testimonial-text";
var _8 = "ra-cms-module-testimonial-type-large";
export { _1 as "cmsModuleTestimonialAuthorCls", _2 as "cmsModuleTestimonialCls", _3 as "cmsModuleTestimonialDetailsCls", _4 as "cmsModuleTestimonialFooterCls", _5 as "cmsModuleTestimonialLinkCls", _6 as "cmsModuleTestimonialStarsCls", _7 as "cmsModuleTestimonialTextCls", _8 as "cmsModuleTestimonialTypeLargeCls" }
